import Vue from "vue";
import VueApexcharts from "vue-apexcharts";

Vue.use(VueApexcharts);
Vue.component("apexchart", VueApexcharts);
